/* src/app/shared/components/modals/export-progress-modal/export-progress-modal.component.scss */
.export-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 2rem;
  gap: 1.2rem;
}
.format-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 1px;
}
.format-badge ion-icon {
  font-size: 1.2rem;
}
.percentage-text {
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1;
  color: var(--ion-color-medium);
}
.progress-bar-track {
  width: 100%;
  height: 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
}
.progress-bar-fill {
  height: 100%;
  border-radius: 6px;
  background: var(--ion-color-medium);
  transition: width 0.4s ease;
}
.hint-text {
  font-size: 0.85rem;
  opacity: 0.6;
  text-align: center;
  margin: 0;
}
/*# sourceMappingURL=export-progress-modal.component-ZZVDTTTJ.css.map */
